export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const SPECILITY_REQUEST = "SPECILITY_REQUEST";
export const SPECILITY_SUCCESS = "SPECILITY_SUCCESS";
export const SPECILITY_ERROR = "SPECILITY_ERROR";

export const specilityRequest = (payload) => ({
  type: SPECILITY_REQUEST,
  ...payload,
});

export const specilitySuccess = (authData) => ({
  type: SPECILITY_SUCCESS,
  authData,
});

export const specilityError = (error) => ({
  type: SPECILITY_ERROR,
  error,
});
export const signupRequest = (payload) => ({
  type: SIGNUP_REQUEST,
  ...payload,
});

export const signupSuccess = (authData) => ({
  type: SIGNUP_SUCCESS,
  authData,
});

export const signupError = (error) => ({
  type: SIGNUP_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/pages/signup/actions.js